import {
  BuildingInfoPut,
  PutBuildingItemReqObj,
  PutBuildingItemResObj
} from '@gateway.Building'
import { yamadumiApi } from '../yamadumi-api'

/** 物件情報一覧・登録/更新・削除 */
export class BuildingMaintenanceGateway {
  static putBuildingItem = async (params: PutBuildingItemReqObj) => {
    // 空文字とundefinedをnullに置換
    // startM,completionMを0埋め
    // 工事科目コードをNumberからStringに置換
    params.data.buildingInfoList = params.data.buildingInfoList.map(v => {
      (Object.keys(v.buildingInfo) as Array<keyof BuildingInfoPut>).forEach((key) => {
        if (v.buildingInfo[key] === '' || v.buildingInfo[key] === undefined) {
          v.buildingInfo[key] = null
        }
        if ((key === 'startM' && v.buildingInfo[key] !== null) || (key === 'completionM' && v.buildingInfo[key] !== null)) {
          v.buildingInfo[key] = v.buildingInfo[key]?.padStart(2, '0') ?? null
        }
        if (key === 'constructionSubjectCd') {
          v.buildingInfo[key] = (v.buildingInfo[key])?.toString() ?? null
        }
      })
      return v
    })
    return await yamadumiApi.put<PutBuildingItemResObj>('/api/building/item', params)
  }
}
